import CandidateSingleRegistrationPage from '../../containers/registration/candidate/CandidateSingleRegistrationPage';
import ManagerSingleRegistrationPage from '../../containers/registration/manager/ManagerSingleRegistrationPage';
import { useRegistration } from './RegistrationContext';
import { Message } from '../../lib/constants/messages';
import Prompt from '../../containers/registration/utils/prompt';

const SignUpPage = () => {
    const {
        setActiveTab,
        setCandidateType,
        digioSuccessData,
        setHasUnsavedChanges,
        candidateId,
        managerId,
        rerenderKey = 0,
        authType,
        hasUnsavedChanges,
        candidateType,
    } = useRegistration();

    return (
        <div>
            {candidateType === 'candidate' ? (
                <CandidateSingleRegistrationPage
                    handleDatAndTab={(key: string, key2: string) => {
                        setTimeout(() => {
                            setActiveTab(key);
                            setCandidateType(key2);
                        }, 300);
                    }}
                    digioSuccessData={digioSuccessData}
                    candidateId={candidateId}
                    key={rerenderKey + 1}
                    hasUnsavedChanges={(value) => setHasUnsavedChanges(value)}
                />
            ) : (
                <ManagerSingleRegistrationPage
                    handleSelect={(key: string, key2: string) => {
                        setActiveTab(key);
                        setCandidateType(key2);
                    }}
                    managerId={managerId}
                    key={rerenderKey + 4}
                    selectedAuthType={authType}
                    hasUnsavedChanges={(value) => setHasUnsavedChanges(value)}
                />
            )}

            <Prompt when={hasUnsavedChanges} message={Message.UNSAVED_CHANGES_MESSAGE} />
        </div>
    );
};

export default SignUpPage;
